export default __webpack_public_path__ + "static/media/newsletter3.0b15b227.jpeg";